import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

import { OscSpinnerComponent } from './components/osc-spinner/osc-spinner.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { RequestAppAccessComponent } from './components/request-app-access/request-app-access.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthErrorInterceptor } from '../auth/auth-error.interceptor';

@NgModule({
  declarations: [
    OscSpinnerComponent,
    ConfirmationModalComponent,
    RequestAppAccessComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true }
  ],
  exports: [
    OscSpinnerComponent,
    RequestAppAccessComponent,
  ],
})
export class OscUtilsModule {
  public static forRoot(): ModuleWithProviders<OscUtilsModule> {
    return {
      ngModule: OscUtilsModule,
    };
  }
}
